import { Modal } from "react-bootstrap";
import styles from "./TrainerSlotsAddModal.module.scss";
import { FaRegTimesCircle, FaTimesCircle } from "react-icons/fa";
import { Calendar, getAllDatesInRange } from "react-multi-date-picker";
import { useEffect, useState } from "react";
import "react-multi-date-picker/styles/colors/teal.css";
import Select from "react-select";
import { trainerAvailableTimeSlots } from "../constants";
import {
  checkTimeOverlapping,
  compareTime,
} from "../../../../../utils/helpers";
import { toast } from "react-toastify";

const CalenderComponent = ({ setDates }: { setDates: CallableFunction }) => {
  const [values, setValues] = useState<any>([]);
  const [deselectWeekend, setDeselectWeekend] = useState(0);

  useEffect(() => {
    const formattedDates = values
      ?.filter((item: any) =>
        !deselectWeekend ? true : !!(item?.weekDay?.index % 6)
      )
      ?.map((item: any) => item?.format("YYYY-MM-DD"));

    setDates([...formattedDates]);
  }, [values, deselectWeekend]);

  return (
    <div>
      <Calendar
        value={values}
        onChange={(dateObjects: any) => {
          setValues(getAllDatesInRange(dateObjects));
        }}
        range={true}
        mapDays={({ date }) => {
          let isWeekend = [0].includes(date?.weekDay?.index);

          if (isWeekend && !!deselectWeekend)
            return {
              disabled: true,
              style: { color: "#ccc" },
              onClick: () => toast.info("Weekends are disabled."),
            };
        }}
        shadow={false}
        className="teal"
      />
      <div className="form-check mt-2">
        <input
          className="form-check-input"
          type="checkbox"
          value={deselectWeekend}
          id="disable-weekend"
          onChange={() => {
            setDeselectWeekend((prev) => (prev ? 0 : 1));
          }}
        />
        <label className="form-check-label" htmlFor="disable-weekend">
          Deselect all weekends
        </label>
      </div>
    </div>
  );
};

const TrainerSlotsAddModal = ({
  onClose,
  onSave,
}: {
  onClose: any;
  onSave: any;
}) => {
  const [selectedDates, setSelectedDates] = useState([]);
  const [timings, setTimings] = useState<any>([]);

  const handleAdd = () => {
    setTimings([
      ...timings,
      {
        availableHourStart: {
          value: "",
          label: "",
        },
        availableHourEnd: {
          value: "",
          label: "",
        },
      },
    ]);
  };

  const handleDelete = (indexToDelete: number) => {
    setTimings([
      ...timings?.filter((item: any, idx: number) => idx !== indexToDelete),
    ]);
  };

  const handleChange = (value: any, index: number, key: string) => {
    const updateArray = timings?.map((item: any, idx: number) => {
      if (index === idx) {
        return {
          ...item,
          [key]: {
            ...value,
          },
        };
      } else {
        return item;
      }
    });
    setTimings([...updateArray]);
  };

  const handleSave = () => {
    const slotTimings = timings?.map((item: any) => ({
      availableHourStart: item?.availableHourStart?.value,
      availableHourEnd: item?.availableHourEnd?.value,
    }));

    if (selectedDates?.length === 0) {
      toast.error("Please select a date");
      return;
    }
    if (slotTimings?.length === 0) {
      toast.error("No slot timings given.");
      return;
    }

    const emptyTimings = slotTimings?.some(
      (item: any) => !item?.availableHourStart || !item?.availableHourEnd
    );
    const slotsWithSameStartAndEndTime = slotTimings?.some(
      (item: any) => item?.availableHourStart === item?.availableHourEnd
    );
    const slotsWithSameStartTimeLessThanEndTime = slotTimings?.some(
      (item: any) =>
        compareTime(item?.availableHourEnd, item?.availableHourStart)
    );

    if (emptyTimings) {
      toast.error("Slots timings should not be empty.");
      return;
    }
    if (slotsWithSameStartAndEndTime) {
      toast.error("Start time and end time should not be same.");
      return;
    }
    if (slotsWithSameStartTimeLessThanEndTime) {
      toast.error("Start time should be less than end time.");
      return;
    }
    if (checkTimeOverlapping(slotTimings)) {
      toast.error("There cannot be any overlapping time slots.");
      return;
    }
    onSave(selectedDates, slotTimings);
  };

  return (
    <Modal show className={styles.slotAddModal}>
      <Modal.Header>
        <Modal.Title>
          <span className="fs-24 fw-700 text-grey-900">Add slot</span>
        </Modal.Title>
        <FaRegTimesCircle
          size={28}
          className="cursor-pointer"
          onClick={onClose}
        />
      </Modal.Header>
      <Modal.Body>
        <div className="p-3">
          <div className="d-flex justify-content-center">
            <CalenderComponent setDates={setSelectedDates} />
          </div>
          <hr />
          <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
            <span className="fw-600 fs-20">Select time</span>
            <button
              className="btn btn-sm btn-outline-secondary btn-sm"
              onClick={handleAdd}
            >
              Add new slot
            </button>
          </div>
          {timings?.length > 0 && (
            <div>
              <div className="row mb-2 align-items-center">
                <div className="col-5">
                  <span className="fw-600">Start time</span>
                </div>
                <div className="col-5 offset-1">
                  <span className="fw-600">End time</span>
                </div>
              </div>
              {timings?.map((item: any, index: number) => {
                return (
                  <div
                    className="row mb-2 align-items-center"
                    key={`slot-${index}`}
                  >
                    <div className="col-5">
                      <Select
                        isMulti={false}
                        value={item?.availableHourStart}
                        onChange={(option: any) => {
                          handleChange(option, index, "availableHourStart");
                        }}
                        className="basic-single"
                        classNamePrefix="select"
                        isClearable={false}
                        isRtl={false}
                        isSearchable={true}
                        name={`availableHourStart-${index}`}
                        options={trainerAvailableTimeSlots}
                      />
                    </div>
                    <div className="col-1 text-center">-</div>
                    <div className="col-5">
                      <Select
                        isMulti={false}
                        onChange={(option: any) => {
                          handleChange(option, index, "availableHourEnd");
                        }}
                        value={item?.availableHourEnd}
                        className="basic-single"
                        classNamePrefix="select"
                        isClearable={false}
                        isRtl={false}
                        isSearchable={true}
                        name={`availableHourEnd-${index}`}
                        options={trainerAvailableTimeSlots}
                      />
                    </div>
                    <div className="col-1 text-danger">
                      <FaTimesCircle
                        className="cursor-pointer"
                        onClick={() => {
                          handleDelete(index);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-block">
        <div className="row py-2">
          <div className="col-6">
            <button
              className="btn btn-outline-secondary w-100 d-block py-2 btn-lg"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
          <div className="col-6">
            <button
              className="btn btn-success w-100 d-block py-2 btn-lg"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TrainerSlotsAddModal;
